import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

// models
import { ApplicationSettings, AdminUiConfigResponse } from '../models/application-settings';
import { Language } from '../models/language';

@Injectable()
export class ConfigService {
  public config: ApplicationSettings;
  private http: HttpClient;

  constructor(backend: HttpBackend) {
    this.http = new HttpClient(backend);
  }

  async load(): Promise<void> {
    const { apiUrl, adminApi } = await lastValueFrom(
      this.http.get<{ apiUrl: string; adminApi: string }>(`aucxis.config.json?d=${Date.now()}`)
    );

    const resolvedBase = this.parseRelativeURL(apiUrl);
    const fullAdminApi = resolvedBase + adminApi;

    const uiConfig = await lastValueFrom(
      this.http.get<AdminUiConfigResponse>(fullAdminApi + 'adminuiconfig')
    );

    this.config = new ApplicationSettings();
    this.config.adminApi = fullAdminApi;
    this.config.applicationCode = uiConfig.applicationCode;
    this.config.clockURL = uiConfig.clockURL;
    this.config.notificationURL = uiConfig.notificationURL;
    this.config.reportingApiURL = uiConfig.reportingApiURL;
    this.config.privacyPolicyUrl = uiConfig.privacyPolicyUrl;
    this.config.validateEmail = uiConfig.validateEmail;
    this.config.expirationTimeMinutes = uiConfig.expirationTimeMinutes;
    this.config.expirationTimeDays = uiConfig.expirationTimeDays;
    this.config.checkLogoutIntervalMinutes = uiConfig.checkLogoutIntervalMinutes;
    this.config.expirationBufferTimeMinutes = uiConfig.expirationBufferTimeMinutes;
    this.config.authZeroSettings = uiConfig.authZeroSettings;

    this.getLanguages(fullAdminApi + 'language');

    console.log('applicationCode: ' + this.config.applicationCode);
    console.log('adminApi: ' + this.config.adminApi);
    console.log('notificationURL: ' + this.config.notificationURL);
    console.log('clockURL: ' + this.config.clockURL);
  }

  parseRelativeURL(url: string): string {
    if (url && url.indexOf('http') === -1) {
      return new URL(url, window.location.href).href;
    }
    return url;
  }

  private getLanguages(path: string) {
    this.http.get(path).subscribe((languages: Array<Language>) => {
      this.config.languages = languages;
    });
  }

  // Get Clock Service URL from Clock UI config
  getClockServiceUrl(clockUIConfig: any): string {
    const href = window.location.href;

    let defaultSocketUrl = '';
    let socketUrl = '';

    clockUIConfig.baseURLs.forEach(url => {
      if (href.indexOf(url.webUrl) !== -1) {
        // Save base URL if exists
        socketUrl = url.socketUrl;
      } else if (url.webUrl === '*') {
        // Save default URL
        defaultSocketUrl = url.socketUrl;
      }
    });

    // Use default Socket URL if Socket URL is missing for currently accessed URL
    if (socketUrl === '' || socketUrl === undefined) {
      socketUrl = defaultSocketUrl;
    }

    return socketUrl;
  }
}
